// extracted by mini-css-extract-plugin
export var conversationListItem = "_yl-2";
export var fullBleedList = "_yl-3";
export var messageText = "_yl-1";
export var previewText = "_yl-0";